import styled from '@emotion/styled';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  shouldForwardProp,
} from '../../theming';

export interface BaseAnchorProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    ShadowProps,
    SpaceProps,
    TypographyProps {}

export type AnchorProps = React.PropsWithRef<BaseAnchorProps>;

export const Anchor = styled('a', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<BaseAnchorProps>(prop as keyof BaseAnchorProps),
})<AnchorProps>(
  defineWithTheme('anchors'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    shadow,
    space,
    typography,
  ),
);
